import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import routes from 'app/routes';
import { Accordion, Button } from 'react-bootstrap5';
import Modal from 'components/new_ui/Modal/Modal';

import { useContext as useTemplatesContext } from 'components/Managers/Templates/Context';

import { clearStorage } from 'components/ProgramBuilder/Storage';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

export default function ModalChooseTemplate({ show, onClose }) {
  const { dispatch: dispatchTemplates, actions: actionsTemplates, state: stateTemplates } = useTemplatesContext();
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const createNewTemplate = (template) => {
    setLoading(true);
    actionsTemplates.new(dispatchTemplates, template && template.id, (data) => {
      setLoading(false);
      onClose();
      clearStorage();

      navigate(
        routes.managers.templates.chooseTopics,
        {
          state: {
            template: data,
          },
        },
      );
    });
  };

  return (
    <Modal onHide={onClose} show={show} header="My Coaching Programs">
      <Accordion>
        {stateTemplates.templates && stateTemplates.templates.filter((item) => item.attributes.type === 'Program')
          .map((template) => (
            <Accordion.Item
              key={template.id}
              eventKey={`template-${template.id}`}
            >
              <Accordion.Header>{template.attributes.title}</Accordion.Header>
              <Accordion.Body>
                <ul>
                  {template.attributes.steps.slice(0, template.attributes.sessions).map((step) => (
                    <li key={step.id}>
                      {step.title}
                    </li>
                  ))}
                </ul>

                <div className="text-end">
                  <Button
                    onClick={() => createNewTemplate(template)}
                    disabled={loading}
                  >
                    {loading && <LoadingPlaceholder placement="inline" />}
                    {' '}
                    Apply as a Template
                  </Button>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          ))}
      </Accordion>
    </Modal>
  );
}

ModalChooseTemplate.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
};

ModalChooseTemplate.defaultProps = {
  show: false,
  onClose: () => {},
};
